import ArrayUtils from '../utils/ArrayUtils'
import i18n from '../i18n'

const VacationRequestTypeEnum = Object.freeze({
  1: i18n.t('RequestType.NewRequest'),
  3: i18n.t('RequestType.RefuseRequest'),
  4: i18n.t('RequestType.ReturnRequest'),
  2: i18n.t('RequestType.ConfirmRequest'),
  5: i18n.t('RequestType.AllRequest'),
  7: i18n.t('RequestType.SuspendRequest'),
})

const VacationRequestTypeArray = function () {
  return ArrayUtils.EnumToArray(VacationRequestTypeEnum)
}
export default { VacationRequestTypeEnum, VacationRequestTypeArray };